import * as preact from "preact";
import { createPortal } from "preact/compat";
import noderef from "../../foundation/utils/noderef";

const { h } = preact;

class Portal extends preact.Component {
    findNode = node => (typeof node === "string" ? document.querySelector(node) : node);

    componentDidMount() {
        const { didRender } = this.props;
        const { portal } = this.nodeRefs;

        if (didRender) {
            didRender(portal.firstChild);
        }
    }

    render() {
        const { children, into } = this.props;

        return createPortal(
            <div ref={noderef(this, "portal")}>{children}</div>,
            this.findNode(into)
        );
    }
}

Portal.defaultProps = {
    into: document.body
};

export default Portal;
